import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'components/tooltip';

export default function UserIcon({ admin, tooltipPlacement, size, user }) {
  const adminImageUrl = '/images/default-profile-photo.png';
  const tooltip = admin ? 'Buildout' : `${user.role ? `${user.role}: ` : ''}${user.name || user.email}`;

  return (
    <span className={classNames('avatar', size && `avatar-${size}`)}>
      <Tooltip content={tooltip} dark placement={tooltipPlacement}>
        <img
          className="avatar-image w-100 h-100 object-fit-cover"
          src={admin ? adminImageUrl : user.imageUrl}
          title={tooltip}
        />
      </Tooltip>
    </span>
  );
}

UserIcon.propTypes = {
  admin: PropTypes.bool,
  size: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  user: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    name: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
};
